import type {
  LinkedAccounts,
  ProviderLabel,
  ProviderName,
} from 'bundles/third-party-auth/components/AccountLink/types';
import { SSOTypes, type SSO_TYPE } from 'bundles/third-party-auth/lib';

const OAUTH_PROVIDERS: ProviderName[] = ['facebook', 'apple', 'google'];

const SSO_TYPE_VALUES = Object.values(SSOTypes) as string[];

export const isSsoType = (value: string): value is SSO_TYPE => SSO_TYPE_VALUES.includes(value);

export const isSsoLinked = (linked: LinkedAccounts): boolean => !!linked.saml || !!linked.jwt;

export const PROVIDER_LABELS: Record<ProviderName, ProviderLabel> = {
  facebook: 'Facebook',
  apple: 'Apple',
  google: 'Google',
};

export const getLinkedOAuthProvider = (linked: LinkedAccounts): ProviderLabel | null => {
  const provider = OAUTH_PROVIDERS.find((p) => !!linked[p]);
  return provider ? PROVIDER_LABELS[provider] : null;
};

export const isOAuthDisabled = (provider: ProviderName, linked: LinkedAccounts): boolean => {
  if (isSsoLinked(linked)) {
    return true;
  }

  return OAUTH_PROVIDERS.filter((p) => p !== provider).some((p) => !!linked[p]);
};
